import { useCallback } from 'react';
import { memo } from 'react';
import { Box, List, Text } from '@betty/moonlight';
import { useDispatch, useSelector } from '@betty/toolkit/state';
import { FreeSpin } from '../../services/RewardsService.schemas';
import { ListRenderItem } from 'react-native';
import FreeSpinsGame from './FreeSpinsGame';
import {
  fetchFreeSpins,
  selectFreeSpins,
  selectFreeSpinsDataState,
} from '../../state/rewards.slice';
import { useFocusEffect } from '@betty/navigation';
import FreeSpinsSkeleton from './FreeSpinsSkeleton';
import FreeSpinsEmpty from './FreeSpinsEmpty';
function FreeSpinsSection() {
  const dispatch = useDispatch();
  const freeSpinsDataState = useSelector(selectFreeSpinsDataState);
  const freeSpins = useSelector(selectFreeSpins);

  useFocusEffect(
    useCallback(() => {
      dispatch(fetchFreeSpins());
    }, [dispatch]),
  );

  const renderSeparator = useCallback(() => <Box width="space-400" />, []);

  const renderItem = useCallback<ListRenderItem<FreeSpin>>(({ item }) => {
    return (
      <>
        {item.games.map((game) => (
          <FreeSpinsGame
            id={game.id}
            spinsLeft={item.freeSpinsLeft}
            key={game.id}
          />
        ))}
      </>
    );
  }, []);

  return (
    <Box
      flex={1}
      marginTop="space-400"
      paddingHorizontal="space-400"
      gap="space-200"
    >
      <Text
        variant="h6"
        locNS="rewards"
        locKey="yourFreeSpins"
        gradient="darkSurfaceAccent"
      />
      {freeSpins.length ? (
        <List
          data={freeSpins}
          renderItem={renderItem}
          showsHorizontalScrollIndicator={false}
          horizontal
          ItemSeparatorComponent={renderSeparator}
          ListEmptyComponent={
            freeSpinsDataState === 'rejected' ? <FreeSpinsSkeleton /> : null
          }
        />
      ) : (
        <FreeSpinsEmpty />
      )}
    </Box>
  );
}

export default memo(FreeSpinsSection);
